module.exports = __webpack_public_path__ + "static/icon-funding-1451968d2c439317d22966c2245069df.png";